<template>
    <v-ons-alert-dialog
        data-test-id="dlg-validation"
        title="Please check the following fields:"
        v-bind:visible.sync="show"
        v-bind:footer="{ OK: () => this.$emit('show', false) }">
        <ul>
            <li v-for="error in errors">
                {{ Array.isArray(error) ? error[0] : error }}
            </li>
        </ul>
    </v-ons-alert-dialog>
</template>

<script>
    export default {
        props: ['show', 'errors'],
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/js/components/fragments/validation.vue